import {createStore, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from '../reducers';
import {persistStore} from 'redux-persist';

const store = createStore(rootReducer, applyMiddleware(thunkMiddleware));
const persistor = persistStore(store);

export {store, persistor};
